import ajax from './ajax';

export function contactUs(params) {
  return ajax('/ContactQueri/CreateConactQury', { method: 'POST', data: params });
}


export function subscribeToNewsLetter(params) {
  return ajax('/newsletters', { method: 'POST', data: params });
}

